export default __webpack_public_path__ + "69d87cbec5e042d07c6fd436672845fa.png";